import { AuthenticationContext } from 'hooks/useAuthentication'
import React, { useState } from 'react'

export function AuthProvider({ children }) {
  const [isAuth, setIsAuth] = useState(() => {
    const token = window.localStorage.getItem('__atk__')
    return Boolean(token)
  })

  const values = { isAuth, setIsAuth: (value = true) => setIsAuth(value) }

  return (
    <AuthenticationContext.Provider value={values}>
      {children}
    </AuthenticationContext.Provider>
  )
}
